import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	title: {
		id: 'polaris-components-quickstart.tasks.link-work-items.title',
		defaultMessage: 'Link Jira work items',
		description: 'The title appears on the list of onboarding tasks in the sidebar',
	},
	description: {
		id: 'polaris-components-quickstart.tasks.link-work-items.description',
		defaultMessage: 'Move ideas forward with Jira work items to track the delivery progress.',
		description:
			'The description appears on the expanded task item of onboarding quickstart sidebar below the title',
	},
	tip: {
		id: 'polaris-components-quickstart.tasks.link-work-items.tip',
		defaultMessage: 'Add delivery progress field to your view.',
		description:
			'The tip appears on the expanded task item of onboarding quickstart sidebar below the description',
	},
	roleRestrictionsText: {
		id: 'polaris-components-quickstart.tasks.link-work-items.role-restrictions-text',
		defaultMessage: "Contributors can't link or create work items.",
		description: 'Text describing role restrictions',
	},
});
